<template>
    <div class="home-content member-wrapper">
        <div class="hint-text">请至少添加一个成员，最多添加两个成员</div>
        <div class="operate-button-wrapper">
            <button class="operate-button" @click="handleAddMember">添加成员</button>
        </div>
        <van-dialog v-model="isShowInputDialog" title="新增成员" @confirm="handleSubmit" show-cancel-button>
            <input type="text" v-model="memberForm.name" class="input-member-item" placeholder="请输入成员名称">
            <input type="password" v-model="memberForm.devicePwd" class="input-member-item" placeholder="请输入4-8位设备启动密码">
        </van-dialog>
    </div>
</template>

<script>
    import { mapActions} from 'vuex';
    export default {
        name: "AddMemberHome",
        data() {
            return {
                isShowInputDialog: false,
                memberForm: {
                    name: '',
                    devicePwd: ''
                }
            }
        },
        methods: {
            handleAddMember() {
                this.isShowInputDialog = true;
            },

            handleSubmit() {
                if (!this.memberForm.name) {
                    this.$toast.fail("成员名不能为空");
                    return;
                }
                let devicePwd = this.memberForm.devicePwd;
                if (!devicePwd || devicePwd.length < 4 || devicePwd.length > 8) {
                    this.$toast.fail("设备启动密码必须4-8位");
                    return;
                }
                this.netAddMember(this.memberForm);
            },
            /**
             * 添加成员
             * @param params
             * @returns {Promise<void>}
             */
            async netAddMember( params ) {
                const toast = this.$toast.loading({
                    message: '请稍等...',
                    forbidClick: true,
                    duration: 0
                });
                try {
                    await this.$req.addMember({
                        ...params
                    });
                    let members = await this.getMembers();
                    this.isShowInputDialog = false;
                    this.$router.replace('/home/addReportHome?memberId=' + members[0].id, null, () => {});
                }catch (e) {
                    //TODO
                } finally {
                    toast.clear();
                }
            },

            ...mapActions([
                'getMembers'
            ])
        }
    }
</script>